import { Layout, Menu, Drawer } from 'antd';
import { Link } from 'react-router-dom';
import Icon from "../components/Icon";
import { FEATURES } from '../config/features';

const { Sider } = Layout;

interface propsType {
    menuCollapsed: boolean,
    selectedMenu: string,
    isDesktop: boolean,
    toggle: () => void,
    logoUrl: string,
    serviceNowAdmin: boolean,
    showVisitorManagement?: boolean
}


export const SideMenu = ({ menuCollapsed, selectedMenu, isDesktop, toggle, logoUrl, serviceNowAdmin, showVisitorManagement = false }: propsType) => {
    const settingsMenuKeys = ['feature-management', 'service-now-settings', 'ir-inception-settings'];
    const defaultOpenKeys = settingsMenuKeys.includes(selectedMenu) ? ['settings'] : [];
    const showServiceNowSettings = FEATURES.serviceNowSettings.enabled && serviceNowAdmin;
    const showInceptionSettings = FEATURES.inceptionSettings.enabled && serviceNowAdmin;
    const menuItems = (
        <Menu theme="light" mode="inline" defaultSelectedKeys={[selectedMenu]} defaultOpenKeys={defaultOpenKeys}>
            {FEATURES.users.enabled && (
                <Menu.Item key="users">
                    <Link to="/users">
                        <Icon icon="users" hovered={true} />
                        Users
                    </Link>
                </Menu.Item>
            )}
            {FEATURES.visitorManagement.enabled && showVisitorManagement && (
                <Menu.Item key="visitor-management">
                    <Link to="/visitor-management">
                        <Icon icon="manager" hovered={true} />
                        Visitor Management
                    </Link>
                </Menu.Item>
            )}
            {FEATURES.newsFeed.enabled && (
                <Menu.Item key="news-feed">
                    <Link to="/news-feed">
                        <Icon icon="news-feed" hovered={true} />
                        Newsfeed
                    </Link>
                </Menu.Item>
            )}
            {FEATURES.bookingSpace.enabled && (
                <Menu.Item key="booking-space">
                    <Link to="/booking-space">
                        <Icon icon="booking-space" hovered={true} />
                        Space Bookings
                    </Link>
                </Menu.Item>
            )}
            {FEATURES.deskBooking.enabled && (
                <Menu.Item key="desk-booking">
                    <Link to="/desk-booking">
                        <Icon icon="desk-booking" hovered={true} />
                        Desk Bookings
                    </Link>
                </Menu.Item>
            )}
            {FEATURES.inductions.enabled && (
                <Menu.Item key="inductions">
                    <Link to="/inductions">
                        <Icon icon="play-video" hovered={true} />
                        Videos
                    </Link>
                </Menu.Item>
            )}
            {FEATURES.buildingContacts.enabled && (
                <Menu.Item key="building-contacts">
                    <Link to="/building-contacts">
                        <Icon icon="building" hovered={true} />
                        Building Contacts
                    </Link>
                </Menu.Item>
            )}
            {FEATURES.issues.enabled && (
                <Menu.Item key="issues">
                    <Link to="/issues">
                        <Icon icon="issues" hovered={true} />
                        Issues
                    </Link>
                </Menu.Item>
            )}
            {(FEATURES.featureManagement.enabled || showServiceNowSettings || showInceptionSettings) && (
                <Menu.SubMenu
                    key="settings"
                    title={<span><Icon icon="settings" hovered={true} />Settings</span>}
                >
                    {FEATURES.featureManagement.enabled && (
                        <Menu.Item key="feature-management">
                            <Link to="/feature-management">
                                <Icon icon="star" hovered={true} />
                                Feature Management
                            </Link>
                        </Menu.Item>
                    )}
                    {showServiceNowSettings && (
                        <Menu.Item key="service-now-settings">
                            <Link to="/service-now-settings">
                                <Icon icon="edit-note" hovered={true} />
                                ServiceNow Settings
                            </Link>
                        </Menu.Item>
                    )}
                    {showInceptionSettings && (
                        <Menu.Item key="ir-inception-settings">
                            <Link to="/ir-inception-settings">
                                <Icon icon="edit-note" hovered={true} />
                                IR Inception Settings
                            </Link>
                        </Menu.Item>
                    )}
                </Menu.SubMenu>
            )}
        </Menu>);

    return (
        !isDesktop ? <Drawer
            placement="left"
            closable={false}
            onClose={toggle}
            width={250}
            visible={menuCollapsed}
            className="side-drawer"
        >
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '100%' }}>
                <div>
                    <div className="menu-logo" >
                        {logoUrl && <img src={logoUrl} alt="User-Icon" />}
                    </div>
                    {menuItems}
                </div>
                <div>
                    <div className="menu-int-logo" >
                        <img src="/images/inTenant.png" alt="InTenant-Icon" />
                    </div>
                    <div className='menu-links'>
                        <a href='/#'>FAQ</a>
                        <a href='/#'>Support</a>
                    </div>
                </div>
            </div>
        </Drawer> :
            <Sider trigger={null} collapsible collapsed={menuCollapsed} className="side-menu">
                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '100%' }}>
                    <div>
                        <div className="menu-logo" >
                            {logoUrl && <img src={logoUrl} alt="Tenant logo" />}
                        </div>
                        {menuItems}
                    </div>
                    <div>
                        <div className="menu-int-logo" >
                            <img src="/images/inTenant.png" alt="InTenant-Icon" />
                        </div>
                        <div className="menu-links">
                            <p><a href='https://www.buildingspacesgroup.com.au/intenant.html'>FAQ</a></p>
                            <p><a href='mailto:support@buildingspacesgroup.com.au'>Support</a></p>
                        </div>
                    </div>
                </div>
            </Sider>
    )
}
